import script from "./BGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./BGrid.vue?vue&type=script&lang=ts&setup=true"

import "./BGrid.vue?vue&type=style&index=0&id=4ba6d908&lang=scss"

const __exports__ = script;

export default __exports__